import { useCombobox, useMultipleSelection } from 'downshift';
import * as React from 'react';

import { Avatar } from '../avatar';
import { MoreActionMenu } from '../more-menu';

const { useState } = React;

export const ShareInvite = ({
  members,
}: {
  members: { firstname: string; memberId: string; email: string; type: string }[];
}) => {
  const [inputValue, setInputValue] = useState('');

  const {
    getSelectedItemProps,
    getDropdownProps,
    addSelectedItem,
    removeSelectedItem,
    selectedItems,
  } = useMultipleSelection<{ firstname: string; memberId: string; email: string; type: string }>({
    initialSelectedItems: [],
  });
  const getFilteredItems = (
    items: { firstname: string; memberId: string; email: string; type: string }[]
  ) =>
    items.filter(
      (item) =>
        item.firstname.toLowerCase().startsWith(inputValue.toLowerCase()) ||
        item.email.toLowerCase().startsWith(inputValue.toLowerCase())
    );
  const {
    isOpen,
    getToggleButtonProps,
    getLabelProps,
    getMenuProps,
    getInputProps,
    getComboboxProps,
    highlightedIndex,
    getItemProps,
    selectItem,
    openMenu,
  } = useCombobox({
    inputValue,
    items: getFilteredItems(members),
    onStateChange: ({ inputValue, type, selectedItem, highlightedIndex }) => {
      switch (type) {
        case useCombobox.stateChangeTypes.InputChange:
          inputValue !== undefined && setInputValue(inputValue);
          break;
        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.ItemClick:
          if (selectedItem) {
            selectItem(selectedItem);
            addSelectedItem(selectedItem);
          }
          break;
        case useCombobox.stateChangeTypes.InputBlur:
          if (selectedItem) {
            setInputValue('');
            addSelectedItem(selectedItem);
          }

          break;
        default:
          break;
      }
    },
  });

  return (
    <div className="bg-white">
      <div className="p-20 flex items-center">
        <label {...getLabelProps()} className=" text-gray-600">
          Invite:{' '}
        </label>
        {selectedItems.map((selectedItem, index) => (
          <span key={`selected-item-${index}`} {...getSelectedItemProps({ selectedItem, index })}>
            {selectedItem}
            <button onClick={() => removeSelectedItem(selectedItem)}>&#10005;</button>
          </span>
        ))}
        <div {...getComboboxProps()}>
          <input
            {...getInputProps(
              getDropdownProps({ preventKeyAction: isOpen, onFocus: () => openMenu() })
            )}
            className="placeholder-gray-500 ml-8 text-sm w-full"
            placeholder="Search emails or names"
          />
        </div>
      </div>
      <ul {...getMenuProps()}>
        {isOpen &&
          getFilteredItems(members).map((item, index) => (
            <li
              style={highlightedIndex === index ? { backgroundColor: '#bde4ff' } : {}}
              key={`${item}${index}`}
              {...getItemProps({ item, index })}
            >
              {item.firstname}
            </li>
          ))}
      </ul>
      {!isOpen ? (
        <>
          <p className="bg-gray-100 text-gray-600 text-sm py-10 px-20">Shared with</p>
          <div className="flex items-center justify-between px-20 py-16">
            <div className="flex items-center w-full">
              <Avatar name="Salvador" type="photo" />
              <div className="ml-12">
                <p className="text-sm font-medium">Salvador</p>
                <p className="text-xs">
                  <span className=" font-medium">Guest</span> -{' '}
                  <span className="">salva@gmail.com</span>
                </p>
              </div>
            </div>
            <MoreActionMenu menuItems={[{ label: 'Full access', value: 'full-access' }]} />
          </div>
        </>
      ) : null}
    </div>
  );
};

const items = [
  'Neptunium',
  'Plutonium',
  'Americium',
  'Curium',
  'Berkelium',
  'Californium',
  'Einsteinium',
  'Fermium',
  'Mendelevium',
  'Nobelium',
  'Lawrencium',
  'Rutherfordium',
  'Dubnium',
  'Seaborgium',
  'Bohrium',
  'Hassium',
  'Meitnerium',
  'Darmstadtium',
  'Roentgenium',
  'Copernicium',
  'Nihonium',
  'Flerovium',
  'Moscovium',
  'Livermorium',
  'Tennessine',
  'Oganesson',
];
